// src/pages/geolocation.js (o src/utils/geolocation.js se preferisci)
export function getCurrentLocation() {
  if (!navigator.geolocation) {
    console.warn("🌍 Geolocalizzazione non supportata");
    throw new Error("Il browser non supporta la geolocalizzazione.");
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      resolve,
      (error) => {
        let message = "Impossibile determinare la posizione.";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "Permesso per la geolocalizzazione negato.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Informazioni sulla posizione non disponibili.";
            break;
          case error.TIMEOUT:
            message = "Timeout nella richiesta di posizione.";
            break;
          default:
            message = "Errore sconosciuto durante la geolocalizzazione.";
        }
        reject(new Error(message));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  });
}

export async function getCityFromCoords(lat, lon) {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
  );
  const data = await res.json();
  return (
    data.address.city ||
    data.address.town ||
    data.address.village ||
    data.address.hamlet ||
    data.display_name
  );
}
